// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1W3zS","icon":"SortAdornment_icon__HBdnJ","up":"SortAdornment_up__3B__n","down":"SortAdornment_down__MaSbH","active":"SortAdornment_active__3UTkC"};